var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "box" },
      [
        _c(
          "router-link",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$store.getters.hasAnyRole(["lyris", "admin"]),
                expression: "$store.getters.hasAnyRole(['lyris','admin'])",
              },
            ],
            staticClass: "is-pulled-right",
            attrs: {
              to: {
                name: "usuarioEditar",
                params: {
                  idOrganization: _vm.idOrganization,
                  idUser: _vm.idUser,
                },
              },
            },
          },
          [_c("i", { staticClass: "fas fa-edit" }), _vm._v(" Editar\n    ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }, [
            _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("CUIL")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", [_vm._v(_vm._s(_vm.usuario.cuil))]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column" }, [
            _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("DNI")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.usuario.cuil.substring(2, _vm.usuario.cuil.length - 1)
                  )
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }, [
            _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("Email")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", [
                _c("a", { attrs: { href: "mailto:" + _vm.usuario.email } }, [
                  _vm._v(_vm._s(_vm.usuario.email)),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column" }, [
            _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("Acceso")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", { staticClass: "is-mono" }, [
                _vm._v(_vm._s(_vm.usuario.acceso)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column" }, [
            _c("h2", { staticClass: "subtitle is-5" }, [
              _vm._v("Espacio asignado"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.usuario.espacio_asignado == null
                      ? "Sin limites"
                      : _vm.usuario.espacio_asignado
                  )
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }, [
            _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("Roles")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tags" },
              [
                _vm._l(_vm.usuario.roles, function (role, index) {
                  return _c("p", { key: index, staticClass: "tag" }, [
                    _vm._v(_vm._s(role.descripcion)),
                  ])
                }),
                _vm._v(" "),
                _vm.usuario.roles.length == 0
                  ? _c("p", [_c("i", [_vm._v("No hay areas asignadas")])])
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column" }, [
            _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("Areas")]),
            _vm._v(" "),
            _vm.usuario.areas.length > 0
              ? _c(
                  "div",
                  { staticClass: "field is-grouped is-grouped-multiline" },
                  _vm._l(_vm.usuario.areas, function (area, index) {
                    return _c("div", { key: index, staticClass: "control" }, [
                      _c("div", { staticClass: "tags has-addons" }, [
                        _c("p", { staticClass: "tag is-dark" }, [
                          _vm._v(_vm._s(area.nombre)),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "tag" }, [
                          _vm._v(_vm._s(area.pivot.cargo)),
                        ]),
                      ]),
                    ])
                  }),
                  0
                )
              : _c("p", [_c("i", [_vm._v("No hay areas asignadas")])]),
          ]),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.usuario.acceso_habilitado
      ? _c("div", { staticClass: "notification is-danger" }, [
          _c("i", { staticClass: "fas fa-user-slash" }),
          _vm._v(" El usuario ha sido dado de baja\n    "),
          _vm.usuario.motivo_baja
            ? _c("span", { staticClass: "is-italic" }, [
                _vm._v("(" + _vm._s(_vm.usuario.motivo_baja) + ")"),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.usuario.keystore
      ? _c("div", { staticClass: "notification is-link" }, [
          _c("i", { staticClass: "fas fa-info-circle" }),
          _vm._v(" El usuario "),
          _c("u", [_vm._v("HA SUBIDO")]),
          _vm._v(" con una copia de seguridad de su certificado\n  "),
        ])
      : _c("div", { staticClass: "notification is-dark" }, [
          _c("i", { staticClass: "fas fa-info-circle" }),
          _vm._v(" El usuario "),
          _c("u", [_vm._v("NO HA SUBIDO")]),
          _vm._v(" con una copia de seguridad de su certificado\n  "),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }